let notifyHandler = null;

export function registerNotifier(handler) {
    notifyHandler = handler;
}

export function notify(payload) {
    if (typeof notifyHandler === 'function') {
        notifyHandler(payload);
    }
}

export function notifySuccess(message) {
    notify({type: 'success', message});
}

export function notifyError(message) {
    notify({type: 'error', message});
}

